export default __webpack_public_path__ + "static/media/dance.f75ad8ba.png";